<template>
  <div class="main-content queryBillingGroup">
    <search-item
      :key="identify"
      :ref="identify"
      :is-append-query="isAppendQuery"
      :show-more-scheme="true"
      :show-simple="true"
      :expand-adv="true"
      :search-item-code="searchItemCode"
      :config-module="configModule"
      :grid-config-module="gridConfigModule"
      :auto-init="searchItemAutoInit"
      :custom-search-items="customSearchItems"
      :custom-sim-query-placeholder="simQueryPlaceholder"
      @query="fetchData"
      @advToggle="scrollCallback"
      @perConfigChange="value=>{perConfigName=value}"
      @refreshGrid="()=>{gridRefreshId+=1}"
      @defaultSearchItemsChange="value=>{defaultSearchItems=value}"
    >
      <template slot="operations">
        <slot name="operations" />
      </template>
      <template slot="searchAreaHeader">
        <slot name="searchAreaHeader" />
      </template>
    </search-item>
    <div class="section grid-wrapper">
      <cargo-ag-grid-wrapper
        :config-module="gridConfigModule"
        :per-config-name="perConfigName"
        :refresh-id="gridRefreshId"
        :grid-params.sync="gridParams"
        :grid-options="gridOptions"
        :column-defs="dynamicColumnDefs"
        :row-data="rowData"
        :show-row-groups="dataListDragGroup"
      />
    </div>
    <div id="footer-wrapper-tab-billing-group" class="pagination-wrapper">
      <div :class="[shouldFixed?'fixedBottom':'']" style="display: flex;justify-content: flex-end;flex-wrap: wrap">
        <span v-if="dataShow && ['tabBillingGroup', 'Writeoff'].includes(viewSource)" v-text="totalAmountToCurrencyBillingGroupGrid.labelText" />
        <span v-if="['tabBillingGroup', 'Writeoff'].includes(viewSource)" v-text="totalAmountToCurrencyBillingGroupGrid.selectionCountLabel" />
        <charge-currency-total-group
          v-if="reCalc && ['tabBillingGroup', 'Writeoff'].includes(viewSource)"
          :key="1"
          :amount-to-currency="localCurrency"
          mode="group"
          :type="totalType"
          :data-provider="totalAmountToCurrencyBillingGroupGrid.dataProvider"
          :data-field="totalDataField"
          :currency-field="totalCurrencyField"
          :rate-field="rateField"
          :ar-field="arField"
          :arap-group="arapGroup"
          :show-wht="showWht"
        />
        <span v-if="showTotalUnverifiedAmount && ['tabBillingGroup', 'Writeoff'].includes(viewSource)" v-text="totalAmountNotWrittenOffLabel" />
        <charge-currency-total-group
          v-if="reCalc && showTotalUnverifiedAmount && ['tabBillingGroup', 'Writeoff'].includes(viewSource)"
          :key="2"
          :amount-to-currency="localCurrency"
          mode="group"
          :type="totalType"
          :data-provider="totalAmountToCurrencyBillingGroupGrid.dataProvider"
          data-field="unverifiedAmount"
          :currency-field="totalCurrencyField"
          :rate-field="rateField"
          :ar-field="arField"
          :arap-group="arapGroup"
          :show-wht="showWht"
        />
        <charge-count-group
          v-if="reCalc && ['MakeInvoice'].includes(viewSource)"
          :key="3"
          :selected-count="totalAmountToCurrencyBillingGroupGrid.selectedCount"
          :data-provider="totalAmountToCurrencyBillingGroupGrid.dataProvider"
          :display-and-count-field-list="totalAmountToCurrencyBillingGroupGrid.displayAndCountFieldList"
          :basic-currency="localCurrency"
          :always-show="true"
        />
      </div>
      <div v-show="appendQuery" class="pagination-container">
        <el-pagination
          style="text-align: left;"
          :total="searchConditions.total"
          layout="total"
        />
      </div>
      <cargo-pagination
        v-show="!appendQuery"
        ref="paginationBillingGroup"
        :config-module="gridConfigModule"
        :total="searchConditions.total"
        :page.sync="searchConditions.pageNum"
        :limit.sync="searchConditions.pageSize"
        @pagination="fetchDataByPage"
      />
    </div>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import ChargeCountGroup from '@/components/Cargo/Act/chargeSummary/ChargeCountGroup.vue'
import ChargeCountDataAdapte from '@/components/Cargo/Act/chargeSummary/ChargeCountDataAdapte'
import ChargeCountField from '@/components/Cargo/Act/chargeSummary/ChargeCountField'
import ChargeCountManager from '@/components/Cargo/Act/chargeSummary/ChargeCountManager'
import ChargeGroupCounter from '@/components/Cargo/Act/chargeSummary/ChargeGroupCounter'
import ChargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as BillingConstants from '@/class/cargo/model/parameters/BillingConstants'
import * as ClearingConstants from '@/class/cargo/model/parameters/ClearingConstants'
import { getGridSelected, getGridSelectedIds, recordSelectedStatus } from '@/utils/agGrid'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cacheName, cache } from '@/utils/cacheManager'
import * as LoadDefaultQueryParam from '@/utils/LoadDefaultQueryParam'
import StrUtils from '@/utils/StrUtils'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getObjectByCache, getCacheListByKey } from '@/utils/basicDataCache'
import { ensureExecuteSuccess, Once, stringToBool } from '@/utils/commonUtil'
import { getBillingGroupList, simpleQueryBillingGroupList } from '@/api/clearing/billingNative'
import lodash from 'lodash'
import moment from 'moment'
import { formatNumberToThousands } from '@/utils'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import * as AdvancedSearchConsts from '@/class/cargo/model/utils/AdvancedSearchConsts'
import CargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'

export default {
  name: 'QueryBillingGroup',
  components: { CargoAgGridWrapper, searchItem, ChargeCountGroup, ChargeCurrencyTotalGroup },
  props: {
    isAppendQuery: { type: Boolean, default: false }, // 追加查询，默认不显示
    identify: { type: String, required: true, default: 'queryBillingGroup' }, // ID
    viewSource: { type: String, required: true, default: 'tabBillingGroup' }, // 引用页面
    isAr: { type: Number, default: -1 }, // 是否应收
    oversea: { type: Number, default: -1 }, // 国内国外 0:国内 1:国外
    advance: { type: Number, default: 0 }, // 是否垫付
    isNeedInvoice: { type: Number, default: -1 }, // 是否需要开票
    hasInvoice: { type: Number, default: -1 }, // 是否开票
    clearingState: { type: Number, default: -1 }, // 核销状态：0:有未销账；1:有已销账；2:全部销完
    inputDateStart: { type: String, default: moment().subtract(2, 'y').format('yyyy-MM-DD') }, // 默认业务日期查询
    inputDateEnd: { type: String, default: '' },
    showVerifiedAmount: { type: Boolean, default: true }, // 是否显示已核销金额
    showUnverifiedAmount: { type: Boolean, default: true }, // 是否显示未核销金额
    showInvoiceState: { type: Boolean, default: true }, // 显示开票状态
    showRealClearingState: { type: Boolean, default: true }, // 显示真实的核销状态
    showSelectionCount: { type: Boolean, default: true }, // 是否显示选中记录数
    showGroupingTotal: { type: Boolean, default: true }, // 是否显示合计
    showChargeCount: { type: Boolean, default: false }, // 是否显示合计:新组件
    showUninvoiceAmount: { type: Boolean, default: false }, // 是否显示未开票金额
    showTotalUnverifiedAmount: { type: Boolean, default: false }, // 显示未销金额总计
    showControlledCharge: { type: Boolean, default: true }, // 是否显示受控费用
    showFba: { type: Boolean, default: false }, // 显示FBA相关列
    showIncoTerm: { type: Boolean, default: true }, // 显示贸易条款
    selectedEntitiesForHedging: { type: Array, default: () => [] }, // 排除
    exceptKeys: { type: Array, default: () => [] }, // 在查询中想要例外的Keys
    exceptAdvancedSearchOption: { type: Object, default: null },
    accountId: { type: Number, default: 0 }, // 对冲开票结算单位
    billingJobStateParam: { type: String, default: 'BillingJobState' }, // BillingJobState, 对账-费用-业务状态查询(对账)
    billingGroupStateParam: { type: String, default: 'BillingGroupState' }, // BillingGroupState, 对账单状态查询
    billingHasPaidOffParam: { type: String, default: 'BillingHasPaidOff' }, // BillingHasPaidOff, 对账-费用-是否已核销(对账)
    totalType: { type: String, default: 'both', validator: (value) => { return ['revenue', 'ar', 'ap', 'both', 'revenueAbs', 'auto'].includes(value) } }, // 合计类型
    totalDataField: { type: String, default: 'amount' }, // 数据字段
    totalCurrencyField: { type: String, default: 'currency' }, // 币种字段
    totalAmountToCurrency: { type: String, default: 'RMB' }, // 折合币种
    rateField: { type: String, default: 'rate' }, // 汇率字段
    arField: { type: String, default: 'ar' }, // 收付字段
    type: { type: String, default: 'revenueAbs', validator: (value) => { return ['revenue', 'ar', 'ap', 'both', 'revenueAbs', 'auto'].includes(value) } }, // // 合计类型
    showTotalGroup: { type: Boolean, default: true }, // 是否显示合计
    arapGroup: { type: Boolean, default: false }, // 是否分实收实付
    defaultOptions: { type: Array, default: () => [] }, // 默认的选项
    defaultOptionValues: { type: Array, default: () => [] }, // 选项的默认值列表
    configModule: { type: String, default: '505' }, // 高级查询条件
    gridConfigModule: { type: String, default: '190904' }, // 列表设置
    internalCharge: { type: Boolean, default: false }, // 内结
    showWht: { type: Boolean, default: false } // 是否需要展示去Wht金额
  },
  data() {
    return {
      localCurrency: 'RMB',
      reCalc: true,
      appendQuery: false, // 追加查询
      dataShow: true, // 底部计算组件文字是否显示
      loading: false,
      customSearchItems: [], // 自定义高级查询项
      defaultSearchItems: [],
      searchItemAutoInit: true,
      searchItemCode: '按对账单查询',
      // configModule: '505',
      simQueryPlaceholder: this.$t('Clearing.QuickSearchReconciliationBillNumber'),
      perConfigName: '',
      gridRefreshId: 0,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        onSelectionChanged: this.toRefreshSelectedCount,
        onRowSelected: this.onRowSelected,
        onRowClicked: this.onRowClicked,
        onRowDoubleClicked: this.onRowDoubleClicked
      },
      columnDefs: [],
      rowData: [],
      searchConditions: {
        total: 0,
        pageNum: 1,
        pageSize: 20,
        snapshotConditions: [], // 高级查询条件（点击查询时的快照状态）
        requires: [],
        jobStates: [], // 业务状态
        billingGroupStates: [], // 对账单状态
        billingHasPaidOffs: '' // 是否已核销(对账)
      },
      showLoading: true, // 是否显示加载中样式
      totalAmountToCurrencyBillingGroupGrid: { // 右下角合计组件相关参数
        labelText: '',
        selectionCountLabel: '',
        selectedCount: 0,
        dataProvider: [], // 数据源
        displayAndCountFieldList: [ // 需要统计的项
          new ChargeCountField(this.$t('Billing.billingView_receivables'),
            'amount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, true)
            ]),
          new ChargeCountField(this.$t('Billing.billingView_payables'),
            'amount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ]),
          new ChargeCountField(this.$t('Billing.billingView_total'),
            'amount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, true),
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ]),
          new ChargeCountField(this.$t('Invoice.invoice_convert'),
            'amount', 'currency', 'rate', ChargeCountManager.DISP_IN_GROUP, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, true),
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ])
        ]
      },
      once: new Once(this),
      selectedItem: {}, // 表格选中项
      selections: [], // 已经选中列表
      shouldFixed: false,
      dataListDragGroup: false, // 是否支持数据列表拖拽分组特性
      queryOfficeId: 0 // 记录查询时的分公司Id
    }
  },
  computed: {
    showWhtTax() {
      return this.showWht && this.$store.getters.currentOffice.whtTaxMode
    },
    // 通用显示列
    dynamicColumnDefs() {
      let columnDefs = [
        {
          headerName: '', width: 60, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        }
      ]
      columnDefs = [
        ...columnDefs,
        { headerName: this.$t('Billing.billingJob_accountStatementNo'), field: 'billingNo', width: 200, enableRowGroup: true },
        { headerName: this.$t('Billing.billingJob_settleAccountsTo'), field: 'accountId', width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          } },
        { headerName: this.$t('Billing.billingJob_creator'), field: 'inputBy', width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          } },
        { headerName: this.$t('Billing.billingView_billType'), field: 'billingType', width: 200, enableRowGroup: true },
        { headerName: this.$t('Billing.billingJob_invoiceHeader'), field: 'title', width: 200, enableRowGroup: true },
        { headerName: this.$t('Billing.billingJob_revenueAndExpenditureType'), field: 'ar', width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.chargeReceivableLabelFun(stringToBool(params.value))
          } },
        { headerName: this.$t('Billing.billingJob_confirmStatus'), field: 'state', width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.billingStateLabelFun(Number(params.value))
          } },
        { headerName: this.$t('Billing.billingJob_invoicingStatus'), field: 'invoiceState', width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.invoiceStateLabelFun(Number(params.value))
          },
          hide: !this.showInvoiceState
        },
        { headerName: this.$t('Billing.billingJob_writeOffStatus'), field: 'realClearingState', width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.clearingStateLabFun(Number(params.value))
          },
          hide: !this.showRealClearingState
        },
        {
          headerName: this.$t('Partners.isFba'),
          colId: 'fba',
          field: 'fba',
          width: 180,
          hide: true,
          enableRowGroup: true,
          valueFormatter: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          }
        },
        {
          headerName: this.$t('baseInfo.mailingAddress.fbaWarehouseCode'),
          colId: 'warehouseCode',
          field: 'warehouseCode',
          width: 180,
          enableRowGroup: true,
          hide: true
        },
        {
          headerName: this.$t('FbaJob.DestinationDistribution'),
          colId: 'destinationDistribution',
          field: 'destinationDistribution',
          width: 180,
          hide: true,
          enableRowGroup: true,
          valueFormatter: (params) => {
            return ColumnUtils.multipleFbaDestinationDistribution(TYPE_NAMES.local_cache_FbaJobConstants$DESTINATION_DISTRIBUTION_LIST, 'code', params.value)
          }
        },
        {
          headerName: this.$t('FbaJob.ExpressNo'),
          colId: 'expressNo',
          field: 'expressNo',
          width: 180,
          enableRowGroup: true,
          hide: true
        },
        {
          headerName: this.$t('FbaJob.RemoteWarehouse'),
          colId: 'remoteWarehouse',
          field: 'remoteWarehouse',
          width: 180,
          enableRowGroup: true,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          }
        },
        {
          headerName: 'Shipment Id',
          colId: 'shipmentId',
          field: 'shipmentId',
          width: 180,
          enableRowGroup: true,
          hide: true
        },
        {
          headerName: 'Reference Id',
          colId: 'referenceId',
          field: 'referenceId',
          width: 180,
          enableRowGroup: true,
          hide: true
        },
        { headerName: this.$t('Billing.billingJob_currency'), field: 'currency', width: 200, enableRowGroup: true },
        { headerName: this.$t('Billing.billingJob_amountOfMoney'), field: 'amount', width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
          },
          summaryMode: 'sum' },
        { headerName: this.$t('Billing.billingJob_notInvoicedMoney'), field: 'uninvoiceAmount', width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
          },
          hide: !this.showUninvoiceAmount,
          summaryMode: 'sum'
        },
        { headerName: this.$t('Billing.billingJob_theAmountOfWriteOffs'), field: 'verifiedAmount', width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
          },
          hide: !this.showVerifiedAmount,
          summaryMode: 'sum'
        },
        { headerName: this.$t('Billing.billingAccount_invoicingInformation'), field: 'invoiceDetail', width: 200, enableRowGroup: true },
        { headerName: this.$t('Billing.billingJob_remarks'), field: 'remark', width: 200, enableRowGroup: true },
        { headerName: this.$t('Billing.billingJob_totalCurrency'), field: 'currencyAmount', width: 200, enableRowGroup: true,
          summaryMode: 'sum' },
        { headerName: this.$t('CargoMsg.Cargo_CooperateBranchId'), colId: 'cooperatebranch', field: 'cooperatebranch', width: 160, minWidth: 160, hide: !this.useOrderCenterMode, enableRowGroup: true },
        { headerName: this.$t('CargoMsg.Cargo_CooperateBusinessType'), colId: 'cooperateBusinessType', field: 'cooperateBusinessType', width: 200, minWidth: 200, hide: !this.useOrderCenterMode, enableRowGroup: true }, {
          headerName: this.$t('CargoMsg.Cargo_StatementReviewStatus'),
          field: 'review',
          initialWidth: 100,
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.billingReviewLabelFunc(Number(params.value))
          },
          hide: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_StatementReviewer'),
          field: 'reviewUser',
          initialWidth: 200,
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          hide: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_StatementReviewTime'),
          field: 'reviewDate',
          initialWidth: 250,
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          hide: true
        },
        { headerName: this.$t('FinanceManage.charge_whtTaxAmount'),
          field: 'whtTaxLocalAmount',
          hide: !this.showWhtTax,
          suppressColumnsToolPanel: !this.showWhtTax,
          enableRowGroup: true,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          width: 100,
          summaryMode: 'sum' },
        { headerName: this.$t('FinanceManage.charge_notWhtAmount'),
          field: 'notWhtAmount',
          hide: !this.showWhtTax,
          suppressColumnsToolPanel: !this.showWhtTax,
          enableRowGroup: true,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          width: 100,
          summaryMode: 'sum' },
        {
          headerName: this.$t('Billing.billingJob_InputDate'), field: 'inputDate', initialWidth: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          hide: true,
          enableRowGroup: true
        }
      ]

      return columnDefs
    },
    totalAmountNotWrittenOffLabel() {
      if (this.totalAmountToCurrencyBillingGroupGrid.dataProvider.length > 0) {
        return this.$t('Billing.billingJob_totalAmountNotWrittenOff')
      } else {
        return ''
      }
    },
    useOrderCenterMode() { // 是否开启接单中心模式
      return RateUtil.useOrderCenterMode()
    }
  },
  watch: {

  },
  async created() {
    await cache.load(cacheName.CONFIG)
    await this.initConfig()
    await ensureExecuteSuccess(() => this.defaultSearchItems && this.defaultSearchItems.length > 0)
    await this.changeCustomSearchItems()
    this.setLocalCurrency()
  },
  beforeMount() {

  },
  mounted() {

  },
  beforeDestroy() {
    // this.documentManage.destory()
  },
  methods: {
    // 配置参数
    async initConfig() {
      this.dataListDragGroup = Number(cache.config.get('DataListDragGroup')) === 1
    },
    // 查询触发
    fetchData({ simpleTriggerMode, conditions }) {
      this.searchConditions.pageNum = 1
      // this.tabBillingGroupHp.fetchData({ simpleTriggerMode, conditions })
      const finallyConditions = []
      if (simpleTriggerMode) {
        this.appendQuery = false
        if (['tabBillingGroup', 'Writeoff'].includes(this.viewSource)) {
          const option = new AdvancedSearchOption(null, 'billingGroup.BILLING_NO', conditions.trim(), OperatorConstants.OPERATOR_LIKE.code)
          finallyConditions.push(option.formatObj2Json())
        }
      } else {
        // 高级查询条件组装
        if (conditions && conditions.length > 0) {
          const advConditions = lodash.cloneDeep(conditions)
          // 获取追加查询条件
          this.appendQuery = JobUtils.appendQueryCondition(advConditions)
          finallyConditions.push(...advConditions)
        }
      }
      // 是否查询受控费用
      if (this.showControlledCharge) {
        // 是否有应付受控费用权限
        const isControlled = this.$checkPermission(['button_Charge_controlled'])
        // 是否有应收受控费用权限
        const isCostControlled = this.$checkPermission(['button_Charge_costControlled'])
        let value = 0
        if (!isControlled && !isCostControlled) {
          value = 1
        } else if (!isControlled) {
          value = 2
        } else if (!isCostControlled) {
          value = 3
        }
        if (value !== 0) {
          const option = new AdvancedSearchOption(null, 'cIsControlled', value, OperatorConstants.OPERATOR_EQUAL.code)
          finallyConditions.push(option.formatObj2Json())
        }
      }
      // 结算单位
      if (this.accountId > 0 && !AdvancedSearchOption.hasField('billingGroup.ACCOUNT_ID', conditions)) {
        const option = new AdvancedSearchOption(null, 'billingGroup.ACCOUNT_ID', this.accountId, OperatorConstants.OPERATOR_EQUAL.code)
        finallyConditions.push(option.formatObj2Json())
      }
      this.showLoading = true
      this.searchConditions.snapshotConditions = lodash.cloneDeep(finallyConditions)
      this.toAdvQueryList(finallyConditions, simpleTriggerMode)
    },
    // 分页触发查询
    fetchDataByPage() {
      this.showLoading = true
      this.toAdvQueryList(this.searchConditions.snapshotConditions)
    },
    // 查看事件
    async toAdvQueryList(conditions, simpleTriggerMode = false) {
      this.queryOfficeId = this.$store.getters.currentOfficeId
      await cache.load(cacheName.CONFIG)
      // 拼接默认的查询条件
      const searchConditions = this.searchConditions
      let inputDate = ''
      if (this.inputDateStart && this.inputDateEnd) {
        inputDate = 'start=' + this.inputDateStart + ' 00:00:00' + ',end=' + this.inputDateEnd + ' 23:59:59'
      } else if (this.inputDateStart && !this.inputDateEnd) {
        inputDate = 'start=' + this.inputDateStart + ' 00:00:00'
      }
      if (inputDate) {
        const condition = new AdvancedSearchOption(null, 'billingGroup.INPUT_DATE', inputDate + ',type=date', OperatorConstants.OPERATOR_RANGE.code)
        conditions.push(condition.formatObj2Json())
      }
      if (this.isAr !== -1) {
        const condition = new AdvancedSearchOption(null, 'billingGroup.AR', this.isAr === 1, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(condition.formatObj2Json())
      }
      if (this.advance !== -1) {
        const condition = new AdvancedSearchOption(null, 'charge.ADVANCE', this.advance === 1, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(condition.formatObj2Json())
      }
      if (this.isNeedInvoice !== -1) {
        const condition = new AdvancedSearchOption(null, 'charge.NEED_INVOICE', this.isNeedInvoice === 1, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(condition.formatObj2Json())
      }
      if (this.hasInvoice !== -1 && !AdvancedSearchOption.hasField(SpecialFieldConstants.BILLING_GROUP_INVOICE_STATE2, conditions) && !AdvancedSearchOption.hasField('invoice.INVOICEDATE', conditions)) {
        const operator = this.hasInvoice === 0 ? OperatorConstants.OPERATOR_IS_NULL.code : OperatorConstants.OPERATOR_IS_NOT_NULL.code
        const condition = new AdvancedSearchOption(null, 'charge.INVOICE_UUID', null, operator)
        conditions.push(condition.formatObj2Json())
      }
      if (searchConditions.billingGroupStates && searchConditions.billingGroupStates.length > 0 && !AdvancedSearchOption.hasField('billingGroup.STATE', conditions)) {
        const billingGroupStateArray = LoadDefaultQueryParam.convertCommonStateToInt(searchConditions.billingGroupStates)
        const condition = new AdvancedSearchOption(null, 'billingGroup.STATE', billingGroupStateArray, OperatorConstants.OPERATOR_IN.code)
        conditions.push(condition.formatObj2Json())
      }
      if (searchConditions.jobStates && searchConditions.jobStates.length > 0 && !AdvancedSearchOption.hasField('job.JOB_STATE', conditions)) {
        const billingJobStateArray = LoadDefaultQueryParam.convertCommonStateToInt(searchConditions.jobStates)
        const condition = new AdvancedSearchOption(null, 'job.JOB_STATE', billingJobStateArray, OperatorConstants.OPERATOR_IN.code)
        conditions.push(condition.formatObj2Json())
      }
      if (this.selectedEntitiesForHedging && this.selectedEntitiesForHedging.length > 0) {
        const condition = new AdvancedSearchOption(null, 'selectedEntitiesForHedging', this.selectedEntitiesForHedging)
        conditions.push(condition.formatObj2Json())
      }
      if (this.oversea > -1) {
        const code = (this.oversea === 0) ? BillingConstants.BILLING_TYPE_INTERNAL.code : BillingConstants.BILLING_TYPE_OVERSEA.code
        const condition = new AdvancedSearchOption(null, 'billingGroup.BILLING_TYPE', code, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(condition.formatObj2Json())
      }
      if (this.clearingState !== -1) {
        const condition = new AdvancedSearchOption(null, 'charge.PAID_OFF', this.clearingState === 1, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(condition.formatObj2Json())
      }
      if (this.exceptKeys.length > 0) {
        const condition = new AdvancedSearchOption(null, 'billingGroup.UUID', this.exceptKeys, OperatorConstants.OPERATOR_NOT_IN.code)
        conditions.push(condition.formatObj2Json())
      }
      if (this.exceptAdvancedSearchOption) {
        conditions.push(this.exceptAdvancedSearchOption.formatObj2Json())
      }
      // 内结
      if (this.internalCharge) {
        const condition = new AdvancedSearchOption(null, 'charge.INTERNAL', true, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(condition.formatObj2Json())
      }
      const requires = []
      if (this.showVerifiedAmount) { requires.push('writeoff') }
      if (this.showInvoiceState || this.showUninvoiceAmount) { requires.push('invoice') }
      if (this.showFba) { requires.push('fba') }
      if (this.showIncoTerm) { requires.push('incoTerm') }

      const requestBody = { conditions, requires: requires, branchId: this.$store.getters.currentOfficeId, pageNum: this.searchConditions.pageNum, pageSize: this.searchConditions.pageSize }
      requestBody.appendQuery = this.appendQuery
      if (this.showLoading) {
        this.loading = getLoading()
      }
      if (simpleTriggerMode) { // 快捷查询
        const selectedStatus = recordSelectedStatus(this.gridOptions.api, 'uuid')
        simpleQueryBillingGroupList(requestBody).then(res => {
          if (['tabBillingGroup', 'Writeoff'].includes(this.viewSource)) {
            this.handleBillingGroupResult(res)
          } else {
            this.handleInvoiceResult(res)
          }
          selectedStatus.revert()
        }).finally(() => {
          if (this.showLoading) {
            this.loading.close()
          }
        })
      } else {
        const selectedStatus = recordSelectedStatus(this.gridOptions.api, 'uuid')
        getBillingGroupList(requestBody).then(res => {
          if (['tabBillingGroup', 'Writeoff'].includes(this.viewSource)) {
            this.handleBillingGroupResult(res)
          } else {
            this.handleInvoiceResult(res)
          }
          selectedStatus.revert()
        }).finally(() => {
          if (this.showLoading) {
            this.loading.close()
          }
        })
      }
    },
    // 对账新版-对账单-高级查询返回结果集处理
    handleBillingGroupResult(res) {
      let results = res.data.list
      if (results && results.length > 0) {
        // 追加查询数据去重
        if (this.appendQuery) {
          results = JobUtils.appendQueryRepeat(this.rowData, results, this.appendQuery)
        }
        this.rowData = results
        this.searchConditions.total = this.appendQuery ? results.length : Number(res.data.total)
        if (this.isAr === -1) {
          this.totalAmountToCurrencyBillingGroupGrid.labelText = this.$t('Message.All2')
        } else if (this.isAr === 0) {
          this.totalAmountToCurrencyBillingGroupGrid.labelText = this.$t('Clearing.Payable')
        } else if (this.isAr === 1) {
          this.totalAmountToCurrencyBillingGroupGrid.labelText = this.$t('Clearing.Receivable')
        }
        this.totalAmountToCurrencyBillingGroupGrid.selectionCountLabel = ''
        this.totalAmountToCurrencyBillingGroupGrid.dataProvider = res.data.list
      } else {
        this.rowData = []
        this.searchConditions.total = 0
        this.totalAmountToCurrencyBillingGroupGrid.labelText = ''
        this.totalAmountToCurrencyBillingGroupGrid.selectionCountLabel = ''
        this.totalAmountToCurrencyBillingGroupGrid.dataProvider = []
      }
    },
    // 开票-按对账单查询结果集处理
    handleInvoiceResult(res) {
      if (res.data.list && res.data.list.length > 0) {
        this.rowData = res.data.list
        this.searchConditions.total = Number(res.data.total)
        this.totalAmountToCurrencyBillingGroupGrid.dataProvider = this.rowData
        this.totalAmountToCurrencyBillingGroupGrid.selectedCount = 0
      } else {
        this.rowData = []
        this.searchConditions.total = 0
        this.totalAmountToCurrencyBillingGroupGrid.dataProvider = []
        this.totalAmountToCurrencyBillingGroupGrid.selectedCount = 0
      }
    },
    // 追加自定义查询条件
    async changeCustomSearchItems() {
      const defaultSearchFields = []
      this.searchConditions.billingHasPaidOffs = cache.config.get(this.billingHasPaidOffParam)
      if (this.searchConditions.billingHasPaidOffs) {
        const value = LoadDefaultQueryParam.getCheckBoxValue(this.searchConditions.billingHasPaidOffs)
        if (value) {
          const searchField = new AdvancedSearchField()
          searchField.multiple = 0
          searchField.itemValue = value
          searchField.itemLabel = 'Payment.wroteOffOrNot'
          searchField.itemName = 'charge.PAID_OFF'
          searchField.fieldType = 'FIELD_CHECKBOX'
          searchField.lock = true
          searchField.defaultSelected = 1
          searchField.selected = 1
          searchField.action = 2
          searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
          searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
          defaultSearchFields.push(searchField.formatObj2Json())
        }
      }
      // 对账单业务状态配置项
      this.searchConditions.jobStates = await LoadDefaultQueryParam.getConfigQueryParam(this.billingJobStateParam, SystemConstants.JOB_STATES)
      if (this.searchConditions.jobStates && this.searchConditions.jobStates.length > 0) {
        const searchField = new AdvancedSearchField()
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemValue = []
        searchField.itemLabel = 'Billing.billingCharge_businessStatus'
        searchField.itemName = 'job.JOB_STATE'
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.dataProvider = this.searchConditions.jobStates
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      // 默认结算单位
      if (this.accountId > 0) {
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.accountId))
        if (company) {
          const searchField = new AdvancedSearchField()
          const options = [{ code: company.cmpIdx, chineseName: company.chineseName, englishName: company.englishName }]
          searchField.itemType = 'select'
          searchField.multiple = 0
          searchField.defaultValue = this.accountId
          searchField.itemLabel = 'Billing.billingJob_settlementCompany'
          searchField.itemName = 'billingGroup.ACCOUNT_ID'
          searchField.fieldType = 'FIELD_COMPANY'
          searchField.lock = true
          searchField.dataProvider = options
          searchField.action = 2
          searchField.defaultSelected = 1
          searchField.selected = 1
          defaultSearchFields.push(searchField.formatObj2Json())
        }
      }
      // 是否已核销
      if (this.viewSource === 'Writeoff') {
        const searchField = new AdvancedSearchField()
        searchField.action = 1
        searchField.itemType = 'select'
        searchField.fieldType = 'FIELD_CHECKBOX'
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.itemName = 'charge.PAID_OFF'
        searchField.itemLabel = 'Billing.billingAccount_writeOffOrNot'
        searchField.itemValue = ''
        searchField.selected = 0
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.defaultValue = ''
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      if (this.useOrderCenterMode) {
        const officeAll = getCacheListByKey(basicCacheKeys.basic_data_Office_All)
        const offices = officeAll.filter(p => p.code !== 'HQ').sort((office1, office2) => office1.officeId > office2.officeId ? 1 : -1)
        offices.forEach(row => { row.code = row.officeId }) // ID
        let searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = 0
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'cooperate.BRANCH_ID'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateBranchId'
        searchField.itemValue = []
        searchField.tagValue = 'officeId'
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = offices
        defaultSearchFields.push(searchField.formatObj2Json())
        // 协作业务类型
        const cooperationTypes = getCacheListByKey(basicCacheKeys.basic_data_CooperationType)
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = 0
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'cooperate.BUSINESS_TYPE'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateBusinessType'
        searchField.itemValue = []
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = cooperationTypes
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      if (this.$checkPermission(['role_ViewHierarchicalListAtFinancial']) || this.$checkPermission(['role_ViewHierarchicalDetailAtFinancial'])) {
        JobUtils.configSearchItemsChildOffice(this.defaultSearchItems, defaultSearchFields)
      }
      if (defaultSearchFields && defaultSearchFields.length > 0) {
        this.customSearchItems = this.customSearchItems.concat(defaultSearchFields)
      }

      if (this.viewSource === 'MakeInvoice') {
        this.searchConditions.billingGroupStates = await LoadDefaultQueryParam.getConfigQueryParam(this.billingGroupStateParam, BillingConstants.BILLING_STATES)
      }
    },
    onRowSelected(event) {
      console.log('onRowSelected', event.data)
      this.selectedItem = {}
      if (event.node.selected && event.data) {
        this.selectedItem = event.data
      }
    },
    onRowClicked(event) {
      console.log('onRowClicked', event.data)
      this.selectedItem = event.data
    },
    onRowDoubleClicked(event) {
      console.log('onRowDoubleClicked', event.data)
      this.selectedItem = event.data
      this.$emit('rowDoubleClicked', this.selectedItem)
    },
    // 列表checkBox选中变更事件
    toRefreshSelectedCount() {
      console.log('toRefreshSelectedCount')
      this.filterChange()
      // this.once.excute(this.refreshSelectedCount, [], 200)
    },
    filterChange() {
      const selections = getGridSelected(this.gridOptions)
      this.dataShow = true
      if (selections.length > 0) {
        this.once.excute(this.refreshSelectedCount, [0, selections], 200)
      } else {
        this.$nextTick(() => {
          const hasDisplay = []
          this.gridOptions.api.forEachNode(node => {
            if (node.displayed) {
              hasDisplay.push(node.data)
            }
          })
          if (hasDisplay.length > 0) {
            if (hasDisplay.length == this.rowData.length) {
              this.once.excute(this.refreshSelectedCount, [], 200)
            }
            if (hasDisplay.length < this.rowData.length) {
              this.once.excute(this.refreshSelectedCount, [1, hasDisplay], 200)
            }
          } else {
            this.dataShow = false
            this.once.excute(this.refreshSelectedCount, [1, hasDisplay], 200)
          }
        })
      }
    },
    refreshSelectedCount(arg, selections) {
      if (arg == 0) {
        this.totalAmountToCurrencyBillingGroupGrid.selectionCountLabel = this.$t('Clearing.Selected') + selections.length + '：'
        this.totalAmountToCurrencyBillingGroupGrid.dataProvider = selections
      } else if (arg == 1) {
        this.totalAmountToCurrencyBillingGroupGrid.selectionCountLabel = ''
        this.totalAmountToCurrencyBillingGroupGrid.dataProvider = selections
      } else {
        this.totalAmountToCurrencyBillingGroupGrid.selectionCountLabel = ''
        this.totalAmountToCurrencyBillingGroupGrid.dataProvider = this.rowData
      }
    },
    scrollCallback() {
      this.$nextTick(() => {
        const container = document.querySelector('.parent-wrapper')
        const footer = document.getElementById('footer-wrapper-tab-billing-group')
        const containerHeight = container.clientHeight - footer.offsetHeight
        const offset = footer.offsetTop - container.scrollTop
        if (offset > containerHeight) {
          this.shouldFixed = true
        } else {
          this.shouldFixed = false
        }
      })
    },
    updateRealtotal(realtotal) {
      this.$refs.paginationBillingGroup.realtotal = realtotal
    },
    setLocalCurrency() {
      this.localCurrency = RateUtil.localCurrencyByOffice()
      if (this.localCurrency !== 'RMB') {
        setTimeout(() => { this.reCalc = false }, 100)
        setTimeout(() => { this.reCalc = true }, 100)
      }
    }
  }
}
</script>
